import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/app/store/store';
import { fetchWarehouseDetails } from '@/app/store/slices/warehouseSlice';
import expiringLocalStorage from '@/app/services/expiringLocalStorage';

export function useDestinationWarehouseRedirect(isAuthenticated: boolean) {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch<AppDispatch>();

    const destination = searchParams.get('destinationWarehouseCode')?.toUpperCase() ?? null;
    const currentWarehouse = expiringLocalStorage.getItem(expiringLocalStorage.localStorageKeys.geolocatedWarehouse);

    useEffect(() => {
        if (!isAuthenticated && destination && currentWarehouse !== destination) {
            // fetch + persist
            dispatch(fetchWarehouseDetails(destination));
            expiringLocalStorage.setItem(expiringLocalStorage.localStorageKeys.geolocatedWarehouse, destination);
        }

        // cleanup URL if param exists
        if (destination) {
            searchParams.delete('destinationWarehouseCode');
            setSearchParams(searchParams, { replace: true });
        }
    }, [destination, isAuthenticated, currentWarehouse, dispatch, searchParams, setSearchParams]);
}
